// Randevu Sistemi API Servisi
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://iyiliginmucitleri.com/api";

const appointmentService = {
  // ============ TECHNOLOJİ ATÖLYESI ============
  
  // Atölye randevusu oluştur
  createTechLabAppointment: async (data, token) => {
    const response = await fetch(`${API_BASE_URL}/appointments/tech-lab`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Randevu oluşturulamadı");
    }
    return await response.json();
  },

  // Atölye randevularını listele
  getTechLabAppointments: async (status = null, token) => {
    const params = new URLSearchParams();
    if (status) params.append("status", status);
    
    const response = await fetch(
      `${API_BASE_URL}/appointments/tech-lab?${params.toString()}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    
    if (!response.ok) throw new Error("Randevular getirilemedi");
    return await response.json();
  },

  // Atölye randevusu detayı
  getTechLabAppointment: async (appointmentId, token) => {
    const response = await fetch(
      `${API_BASE_URL}/appointments/tech-lab/${appointmentId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    if (!response.ok) throw new Error("Randevu bulunamadı");
    return await response.json();
  },

  // Atölye randevusu güncelle
  updateTechLabAppointment: async (appointmentId, data, token) => {
    const response = await fetch(
      `${API_BASE_URL}/appointments/tech-lab/${appointmentId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      }
    );
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Randevu güncellenemedi");
    }
    return await response.json();
  },

  // Atölye randevusu iptal
  cancelTechLabAppointment: async (appointmentId, token) => {
    const response = await fetch(
      `${API_BASE_URL}/appointments/tech-lab/${appointmentId}/cancel`,
      {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    
    if (!response.ok) throw new Error("Randevu iptal edilemedi");
    return await response.json();
  },

  // ============ AKSARAY BINASI ============

  // Aksaray randevusu oluştur
  createAksarayAppointment: async (data, token) => {
    const response = await fetch(`${API_BASE_URL}/appointments/aksaray`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Randevu oluşturulamadı");
    }
    return await response.json();
  },

  // Aksaray randevularını listele
  getAksarayAppointments: async (status = null, roomId = null, token) => {
    const params = new URLSearchParams();
    if (status) params.append("status", status);
    if (roomId) params.append("room_id", roomId);
    
    const response = await fetch(
      `${API_BASE_URL}/appointments/aksaray?${params.toString()}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    if (!response.ok) throw new Error("Randevular getirilemedi");
    return await response.json();
  },

  // Aksaray randevusu detayı
  getAksarayAppointment: async (appointmentId, token) => {
    const response = await fetch(
      `${API_BASE_URL}/appointments/aksaray/${appointmentId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    if (!response.ok) throw new Error("Randevu bulunamadı");
    return await response.json();
  },

  // Aksaray randevusu güncelle
  updateAksarayAppointment: async (appointmentId, data, token) => {
    const response = await fetch(
      `${API_BASE_URL}/appointments/aksaray/${appointmentId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      }
    );
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Randevu güncellenemedi");
    }
    return await response.json();
  },

  // Aksaray randevusu iptal
  cancelAksarayAppointment: async (appointmentId, token) => {
    const response = await fetch(
      `${API_BASE_URL}/appointments/aksaray/${appointmentId}/cancel`,
      {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    
    if (!response.ok) throw new Error("Randevu iptal edilemedi");
    return await response.json();
  },

  // ============ ADMIN İŞLEMLERİ ============

  // Randevuyu onayla (Admin)
  approveAppointment: async (appointmentId, token) => {
    const response = await fetch(
      `${API_BASE_URL}/appointments/${appointmentId}/approve`,
      {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    
    if (!response.ok) throw new Error("Randevu onaylanamadı");
    return await response.json();
  },

  // Randevuyu reddet (Admin)
  rejectAppointment: async (appointmentId, reason, token) => {
    const response = await fetch(
      `${API_BASE_URL}/appointments/${appointmentId}/reject`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ reason })
      }
    );
    
    if (!response.ok) throw new Error("Randevu reddedilemedi");
    return await response.json();
  },

  // Tüm randevuları getir (Admin)
  getAllAppointments: async (type = null, status = null, token) => {
    const params = new URLSearchParams();
    if (type) params.append("type", type);
    if (status) params.append("status", status);
    
    const response = await fetch(
      `${API_BASE_URL}/appointments/admin/all?${params.toString()}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    if (!response.ok) throw new Error("Randevular getirilemedi");
    return await response.json();
  },

  // ============ TAKVIM ============

  // Takvim verisi getir
  getCalendarData: async (type = null, token) => {
    const params = new URLSearchParams();
    if (type) params.append("type", type);
    
    const response = await fetch(
      `${API_BASE_URL}/appointments/calendar?${params.toString()}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    if (!response.ok) throw new Error("Takvim verisi getirilemedi");
    return await response.json();
  },

  // ============ SABİTLER ============

  // Odaları getir
  getRooms: async (token) => {
    const response = await fetch(`${API_BASE_URL}/appointments/data/rooms`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    if (!response.ok) throw new Error("Odalar getirilemedi");
    return await response.json();
  },

  // Birimleri getir
  getUnits: async (token) => {
    const response = await fetch(`${API_BASE_URL}/appointments/data/units`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    if (!response.ok) throw new Error("Birimler getirilemedi");
    return await response.json();
  },

  // Etkinlik türlerini getir
  getEventTypes: async (token) => {
    const response = await fetch(`${API_BASE_URL}/appointments/data/event-types`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    if (!response.ok) throw new Error("Etkinlik türleri getirilemedi");
    return await response.json();
  }
};

export default appointmentService;
